import { Header, Page } from 'redesign';
import { PaymentsTableDataProvider } from './payments-table';

export const Payments = () => {
  return (
    <Page header={<Header titleText="Betalingen" />}>
      <PaymentsTableDataProvider />
    </Page>
  );
};
